export const PALETTE_COLORS = ['#ff7759', '#ffc782', '#f5ff60', '#59e800', '#ff78ff', '#ff2f8f'];
